/**
 * RecaptchaDisclosure — small footer text required by Google when the
 * reCAPTCHA badge is hidden or hard to notice. Shown on auth + public
 * survey screens.
 */
import React from "react";

export function RecaptchaDisclosure({ className = "" }) {
    return (
        <p
            className={`text-[11px] text-[#52525b] mt-4 ${className}`}
            data-testid="recaptcha-disclosure"
        >
            Este site é protegido pelo reCAPTCHA e aplicam-se a{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="link-underline">
                Política de Privacidade
            </a>{" "}
            e os{" "}
            <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="link-underline">
                Termos de Serviço
            </a>{" "}
            da Google.
        </p>
    );
}
